import { Eye, EyeClosedIcon, Settings } from "lucide-react";
import React, { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import AuthLeftSide from "../../components/AuthLeftSide";
import { Formik } from "formik";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ThemeToggle } from "../../components/ThemeToggle";
import { API, IV, post, SECRETKEY } from "../../config";
import LogoSVG from "../../components/LogoSVG";
import FaviconSVG from "../../components/FaviconSVG";
import { ResetPasswordSchema } from "../../lib/Validation";
import CustomLabelText from "../../components/CustomLabelText";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const emailStr = location.search.split("&").pop();
  const email = emailStr.split("=").pop();

  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [showPassword2, setShowPassword2] = useState(false);

  const toggleShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };

  const userId = localStorage.getItem("userId");
  const EmailVerification = localStorage.getItem("EmailVerification");
  const hasToken = localStorage.getItem("ts-auth-token");
  const clientId = localStorage.getItem("clientId");

  var CryptoJS = require("crypto-js");

  const iv = IV;
  const key = SECRETKEY;

  const fkey = CryptoJS.enc.Utf8.parse(key);
  const fiv = CryptoJS.enc.Utf8.parse(iv);

  // *API Call for Reset Password, Password Show and Hide - Start
  const handleFinish = async (values) => {
    try {
      setLoading(true);

      const encPassword = CryptoJS.AES.encrypt(values?.password, fkey, {
        iv: fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const finalEncryptedPassword = encPassword.ciphertext.toString(
        CryptoJS.enc.Base64
      );

      const encConfirmPassword = CryptoJS.AES.encrypt(
        values?.password_confirmation,
        fkey,
        {
          iv: fiv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      const finalEncryptedConfirmPassword =
        encConfirmPassword.ciphertext.toString(CryptoJS.enc.Base64);

      const finalValue = {
        ...values,
        password: finalEncryptedPassword,
        password_confirmation: finalEncryptedConfirmPassword,
      };

      const { data } = await post(API.RESET_PASSWORD, {
        email: email,
        token: query.get("token"),
        ...finalValue,
      });
      if (data.status === 200) {
        setLoading(false);
        navigate("/", { replace: true });
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    userId &&
      EmailVerification &&
      hasToken &&
      // (clientId ? navigate("/businesses") : navigate("/clients"));
      navigate("/trusts");
  }, [userId, EmailVerification, hasToken, clientId, navigate]);
  // *API Call for Reset Password, Password Show and Hide - End

  const handleBackToLogin = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <div className="w-full lg:grid lg:grid-cols-2 min-h-screen">
      {loading && <Spin full={true} />}
      <AuthLeftSide />
      <div className="flex items-center justify-center lg:h-auto min-h-screen lg:flex-row flex-col">
        <LogoSVG className="lg:hidden fixed top-[15%] !text-webPrimary !fill-webPrimary h-28 w-full" />
        <div className="mx-auto grid w-[350px] gap-6">
          <div className="flex flex-col items-center justify-center gap-2 text-center">
            <Settings height={48} width={48} />
            <h1 className="text-3xl font-bold">Reset Password</h1>
            {/* <p className="text-balance text-muted-foreground">
              Enter email address to receive an email to reset your password
            </p> */}
          </div>
          <Formik
            initialValues={{
              email: email,
              password: "",
              password_confirmation: "",
            }}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={handleFinish}
            validationSchema={ResetPasswordSchema}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                className="row needs-validation"
                noValidate
              >
                <div className="grid gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="email">
                      {" "}
                      <CustomLabelText
                        labelText="Email"
                        required={true}
                        errorField={errors?.email}
                      />
                    </Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      // placeholder="m@example.com"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      autoFocus={true}
                      className={
                        errors?.email &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="password">
                      {" "}
                      <CustomLabelText
                        labelText="Password"
                        required={true}
                        errorField={errors?.password}
                      />
                    </Label>

                    <div className="relative">
                      <Input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        className={
                          errors?.password &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {showPassword ? (
                        <span className="absolute top-2 right-2">
                          <Eye
                            width={20}
                            height={20}
                            onClick={toggleShowPassword}
                          />
                        </span>
                      ) : (
                        <span className="absolute top-2 right-2">
                          <EyeClosedIcon
                            width={20}
                            height={20}
                            onClick={toggleShowPassword}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="password_confirmation">
                      <CustomLabelText
                        labelText="Confirm Password"
                        required={true}
                        errorField={errors?.password_confirmation}
                      />
                    </Label>

                    <div className="relative">
                      <Input
                        id="password"
                        name="password_confirmation"
                        type={showPassword2 ? "text" : "password"}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password_confirmation}
                        className={
                          errors?.password_confirmation &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {showPassword2 ? (
                        <span className="absolute top-2 right-2">
                          <Eye
                            width={20}
                            height={20}
                            onClick={toggleShowPassword2}
                          />
                        </span>
                      ) : (
                        <span className="absolute top-2 right-2">
                          <EyeClosedIcon
                            width={20}
                            height={20}
                            onClick={toggleShowPassword2}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <Button type="submit" className="w-full">
                    Confirm
                  </Button>
                </div>
              </form>
            )}
          </Formik>
          <div className="mt-4 text-center text-sm">
            <Link to="/" className="underline" onClick={handleBackToLogin}>
              Back to Login
            </Link>
          </div>
        </div>
        <p className="lg:hidden fixed bottom-0 p-4 text-xs flex items-start gap-1 text-justify">
          <FaviconSVG className="h-5 w-5 !text-webPrimary !fill-webPrimary" />
          <span className="flex-1">
            TrustSoft acknowledges the Traditional Custodians of country
            throughout Australia and their connections to land, sea and
            community. We pay our respect to their Elders past and present and
            extend that respect to all Aboriginal and Torres Strait Islander
            peoples today.
          </span>
        </p>
      </div>
      <div className="fixed top-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default ResetPassword;
